import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  CircularProgress,
  Grid,
  MenuItem,
  Modal,
  Select,
  Switch,
  Typography,
} from '@material-ui/core';
import ActionButton from '../../../components/ActionButton';
import CustomTooltip from '../../../components/CustomTooltip';
import { InfoOutlined } from '@material-ui/icons';
import { getEsercizioCommerciale } from '../../../utils/api/esercizi_commerciali_api';
import { reportApiError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  progress: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 200,
  },
  modalContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'center',
    gap: theme.spacing(3),
    backgroundColor: 'white',
    color: 'black',
    padding: theme.spacing(4),
    borderRadius: '6px',
    boxShadow: theme.shadows[6],
    overflowY: 'auto',
    width: '80%',
    maxWidth: '720px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  dialogTitle: {
    textAlign: 'center',
  },
  sectionHeading: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  warning: {
    textAlign: 'center',
    maxWidth: 480,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  switchLabel: {
    fontSize: '0.875rem',
  },
  selectContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
  selectWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '75%',
  },
  switchContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
});

class ModalSelezioneModalitaModello extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tipologiaItem: true,
      modalitaControllo: this.props.isControlliSelectionBlocked,
      tipologiaRevisioneSelected: 'COMBINATA',
      gestioneOperativaSeparata: false,
      loading: true,
    };
  }

  componentDidMount() {
    // Creating or cloning
    if (!this.props.selectedEsercizio) {
      this.setState({
        gestioneOperativaSeparata: false,
        loading: false,
      });
      return;
    }

    getEsercizioCommerciale(this.props.selectedEsercizio)
      .then((business) =>
        this.setState({
          gestioneOperativaSeparata:
            business.esercizio.gestioneOperativaSeparata,
          loading: false,
        }),
      )
      .catch((error) => {
        reportApiError(error);
      });
  }

  render() {
    const { classes } = this.props;

    const isCreatingNewModello = this.props.manualeBaseId === null;
    const isModelWithGestioneSeparata =
      this.props.tipologiaRevisioneModello === 'DESCRITTIVA';
    const isCloningGestioneCombinata =
      this.props.manualeBaseId !== null &&
      this.props.tipologiaRevisioneModello !== 'DESCRITTIVA';

    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        className={classes.modal}
      >
        {this.state.loading ? (
          <div className={classes.progress}>
            <CircularProgress />
          </div>
        ) : (
          <div className={classes.modalContainer}>
            <Typography variant="h6" className={classes.dialogTitle}>
              Opzioni manuale
            </Typography>
            {this.props.filtroGestioneSeparata === false &&
              this.state.gestioneOperativaSeparata && (
                <Typography
                  variant="body2"
                  color="error"
                  className={classes.warning}
                >
                  N.B. In questo caso il manuale verrà creato con la sola parte
                  descrittiva.
                </Typography>
              )}
            {(isCreatingNewModello || isCloningGestioneCombinata) && (
              <div className={classes.selectContainer}>
                <Typography
                  variant="subtitle1"
                  className={classes.sectionHeading}
                >
                  Modalità di gestione dei controlli di non conformità
                </Typography>
                <div className={classes.selectWrapper}>
                  <CustomTooltip
                    arrow
                    placement="top"
                    title={
                      <Typography variant="caption">
                        Il manuale selezionato è generato da un altro manuale
                        con controlli in modalità <i>semplificata</i> e dunque
                        non è possibile cambiarlo in uno con controlli in
                        modalità <i>normale</i>
                      </Typography>
                    }
                    disableHoverListener={
                      !this.props.isControlliSelectionBlocked
                    }
                  >
                    <Select
                      variant="outlined"
                      fullWidth
                      value={this.state.modalitaControllo}
                      onChange={(e) => {
                        this.setState({
                          modalitaControllo: e.target.value,
                        });
                      }}
                      disabled={this.props.isControlliSelectionBlocked}
                    >
                      <MenuItem value={false}>Normale</MenuItem>
                      <MenuItem value={true}>Semplificata</MenuItem>
                    </Select>
                  </CustomTooltip>
                  <CustomTooltip
                    title={
                      <Typography variant="caption">
                        <b>Modalità normale: </b> i controlli saranno dotati di
                        limiti, cause e azioni correttive.
                        <br />
                        <b>Modalità semplificata:</b> i controlli avranno solo
                        azioni correttive.
                      </Typography>
                    }
                    arrow
                    placement="right"
                  >
                    <InfoOutlined fontSize="small" color="secondary" />
                  </CustomTooltip>
                </div>
              </div>
            )}

            <div className={classes.selectContainer}>
              <Typography
                variant="subtitle1"
                className={classes.sectionHeading}
              >
                Modalità di formattazione del manuale
              </Typography>
              <div className={classes.selectWrapper}>
                <CustomTooltip
                  arrow
                  placement="top"
                  title={
                    <Typography variant="caption">
                      Essendo il modello selezionato compilato dotato di
                      capitoli, l'elemento che si sta creando deve esserne
                      dotato a sua volta.
                    </Typography>
                  }
                  disableHoverListener={!this.props.isChapterSelectionBlocked}
                >
                  <Select
                    disabled={this.props.isChapterSelectionBlocked}
                    value={this.state.tipologiaItem}
                    fullWidth
                    variant="outlined"
                    size="small"
                    onChange={(e) => {
                      this.setState({
                        tipologiaItem: e.target.value,
                      });
                    }}
                  >
                    <MenuItem value={true}>Con capitoli</MenuItem>
                    <MenuItem value={false}>Senza capitoli</MenuItem>
                  </Select>
                </CustomTooltip>
                <CustomTooltip
                  title={
                    <Typography variant="caption">
                      <b>Modalità con capitoli:</b> il manuale sarà dotato,
                      oltre ai paragrafi, di capitoli in cui racchiudere questi
                      ultimi.
                      <br />
                      <b>Modalità senza capitoli:</b> il manuale sarà dotato di
                      soli paragrafi.
                    </Typography>
                  }
                  arrow
                  placement="right"
                >
                  <InfoOutlined fontSize="small" color="secondary" />
                </CustomTooltip>
              </div>
            </div>
            {isCreatingNewModello && (
              <div className={classes.switchContainer}>
                <Typography
                  variant="subtitle1"
                  className={classes.sectionHeading}
                >
                  Gestione operativa separata
                </Typography>
                <Typography component="div" variant="body2">
                  <Grid
                    component="label"
                    container
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid item className={classes.switchLabel}>
                      No
                    </Grid>
                    <Grid item>
                      <Switch
                        checked={
                          this.state.tipologiaRevisioneSelected ===
                          'DESCRITTIVA'
                        }
                        onChange={(e) => {
                          this.setState({
                            tipologiaRevisioneSelected: e.target.checked
                              ? 'DESCRITTIVA'
                              : 'COMBINATA',
                          });
                        }}
                        color="primary"
                      />
                    </Grid>
                    <Grid item className={classes.switchLabel}>
                      Sì
                    </Grid>
                  </Grid>
                </Typography>
              </div>
            )}
            <div>
              <ActionButton
                label="Annulla"
                onClick={() => {
                  this.props.onClose();
                }}
                disabled={false}
                grayVersion={false}
                showAlert={false}
                secondaryButton
              />
              <ActionButton
                label="Prosegui"
                onClick={() => {
                  this.props.onProseguiClicked(
                    this.props.manualeBaseId,
                    this.props.gruppoId,
                    this.state.tipologiaItem,
                    this.props.isModello,
                    this.state.modalitaControllo,
                    isCreatingNewModello || !isModelWithGestioneSeparata
                      ? this.state.tipologiaRevisioneSelected
                      : this.props.tipologiaRevisioneModello,
                  );
                }}
                disabled={false}
              />
            </div>
          </div>
        )}
      </Modal>
    );
  }
}

ModalSelezioneModalitaModello.propTypes = {
  classes: PropTypes.object.isRequired,
  isChapterSelectionBlocked: PropTypes.bool.isRequired,
  isControlliSelectionBlocked: PropTypes.bool.isRequired,
  isModello: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onProseguiClicked: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ModalSelezioneModalitaModello);
